import axiosClient from '@/services/axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

const fetchGlobalSettings = createAsyncThunk(
  'globalSettings/fetchGlobalSettings',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get(`/api/global-setting`);

      return response?.data?.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  },
);

export default fetchGlobalSettings;
